import { COINSTORE_WS_CHANNELS, COINSTORE_WS_TOPOLOGY } from './ws';

import type { ExchangeId } from '../../lib/types';

export const COINSTORE_METADATA = {
  id: 'coinstore' as ExchangeId,
  restDocs: [
    'https://coinstore-openapi.github.io/en/',
    'https://coinstore-openapi.github.io/en/#ticker',
    'https://coinstore-openapi.github.io/en/#get-depth',
    'https://coinstore-openapi.github.io/en/#get-k-line',
  ],
  wsDocs: [
    'https://coinstore-openapi.github.io/en/#websocket-api',
    'https://coinstore-openapi.github.io/en/#subscription-format',
  ],
  wsTopology: COINSTORE_WS_TOPOLOGY,
  wsChannels: COINSTORE_WS_CHANNELS,
  notes: [
    'WebSocket uses numeric instrumentId for subscriptions.',
    'Must fetch symbols first to map symbol to instrumentId.',
    'Symbol format: uppercase no separator (BTCUSDT).',
    'Kline intervals: 1min, 5min, 15min, 30min, 60min, 4hour, 12hour, 1day, 1week.',
    'Response code 0 indicates success.',
  ],
} as const;
